
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-caret",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.015 25.1a1.9 1.9 0 001.551-.564l13.887-14.155a1.912 1.912 0 00-2.729-2.678L16.023 20.649 3.287 7.473a1.912 1.912 0 10-2.749 2.658v-.001l13.914 14.395a1.9 1.9 0 001.571.573l-.008.001z"}})])
          )
        }
      }
    